import {
  storyblokEditable,
  renderRichText,
  StoryblokComponent,
} from "@storyblok/react"

export default function FAQAccordion({ blok }: any) {
  return (
    <section
      {...storyblokEditable(blok)}
      className="bg-white py-24 md:py-28 px-6 md:px-20"
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-10 text-center">
          <div
            className="font-['BeausiteClassic'] font-bold text-[24px] md:text-[32px] text-gray-900"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.heading || { content: [] }) || "",
            }}
          />
          <span className="mt-3 mx-auto block h-[3px] w-16 rounded-full bg-gradient-to-r from-[#4750F5] to-[#8BA3FF]" />
          {blok.blurb?.content?.length ? (
            <div
              className="mt-4 font-['BeausiteClassic'] text-base md:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed"
              dangerouslySetInnerHTML={{
                __html: renderRichText(blok.blurb || { content: [] }) || "",
              }}
            />
          ) : null}
        </div>
        <div className="divide-y divide-gray-200 rounded-2xl border border-gray-100 bg-white/80 shadow-[0_1px_8px_rgba(0,0,0,0.04)]">
          {blok.faqs?.map((nestedBlok: any, i: number) => (
            <StoryblokComponent
              key={nestedBlok._uid}
              blok={nestedBlok}
              isFirst={i === 0}
              isLast={i === blok.faqs.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
